var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"company-bar"},[_c('studio-logo',{attrs:{"id":"overlook","max":3}})],1),_c('div',{staticClass:"copyright text-glow"},[_vm._v("Overlook Studios © 2019-2023")])])}
var staticRenderFns = []

export { render, staticRenderFns }